import Uri from 'urijs';

/* eslint-disable camelcase */
export default function getRedirectToPath() {
  // react-router v8 / the DOM have no `window.location.query` -- that was a
  // react-router v3-ism, so this always read `undefined` and dropped
  // `redirect_to`. Parse the real query string (`window.location.search`)
  // instead so a redirect_to carried into the login flow survives (SNAR-9852).
  const query = new Uri();
  query.query(window.location.search || '');
  const { redirect_to } = query.query(true);

  return redirect_to;
}
